export const discordUrl = "https://discord.gg/hMuzxSkZGn";
export const supportUrl = "https://help.layer.ai";
export const supportEmailUrl = "mailto:support@layer.ai";

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
export const WEEK_IN_MILLISECONDS = 7 * DAY_IN_MILLISECONDS;
